import { cn } from "@/utils";
import { Loader } from "@/components";
import { ChevronRight } from "@/icons";

interface ProfileRowProps {
  name: string;
  onClick?: () => void;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
}

export const ProfileRow = ({
  name,
  onClick,
  className,
  loading,
  disabled,
}: ProfileRowProps) => {
  return (
    <div
      className={cn([
        "flex cursor-pointer justify-between py-[4px]",
        disabled && "text-item-tertiary cursor-not-allowed",
        className,
      ])}
      onClick={!disabled ? onClick : undefined}
    >
      <div>{name}</div>
      {loading ? (
        <div className="flex h-[24px] w-[24px] items-center justify-center">
          <Loader className="h-[16px] w-[16px]" />
        </div>
      ) : (
        <ChevronRight className="h-[24px] w-[24px]" />
      )}
    </div>
  );
};
